<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/color
ib-dialog(v-model="show", autoclose,  width="1356px", height="100%", class="comp-dialog")
    template(slot="default")
        div(class="iframe-headers", v-if="showQuoteDetails === 'new'")
            div(class="iframe-header-info start-16")
                iframe(
                    :src="iframeURL"
                    style="border:none",
                    width="100%",
                    height="100%",
                    title="Contract Details",
                    id="contractFrame",
                    v-if="reloadIframe"
                )
        div
            span(class="icon-close", @click="close", ref="reload")
                +icon-basic-cancel_filled
        div(class="headers", v-if="showQuoteDetails === 'old'")
            div(class="header-info start-16")
                div(class="product-name")
                    h1(class="") {{ results }}
                div(class="disclose")
                    h6(class="") {{ $t('disclosure') }}
                        span(@click="openDisclosure", class="disclose-link") https:ibkr.info/article/2966
            div(class="contract-details")
                div(class="quote-details")
                    div(class="quote-details-headers")
                        div(class="quote-symprice")
                            h3(class="symprice") {{ marketData[7219] }} 
                                span(class="quote-details-data fg70") {{ assetName }} 
                                span(class="quote-details-data fg50") {{ listingExchange }}
                    div(class="quote-details-widgets")
                        div(class="summary")
                            div(v-if="isSummary")
                                ib-progress-circular(v-if="summary.length === 0", width="40px", height="40px", class="alignment")
                                span(v-if="summary") {{ summary }}
                            div(v-else)
                                span(class="warning")
                                    +icon-color-warning 
                                span(class="warn-message") There is no data available for the requested contract.
                        div(class="fundamentals flex-flex")
                            div(class="fundamentals-details start-16 end-16")
                                li Market Cap
                                    span(class="values", v-if="ratios.marketcap") {{ ratios.marketcap }}
                                    span(class="values", v-else-if="!ratios.marketcap") -
                                li P/E
                                    span(class="values", v-if="ratios.pe") {{ ratios.pe }}
                                    span(class="values", v-else-if="!ratios.pe") -
                                li Revenue/Shares
                                    span(class="values", v-if="ratios.ttmrevps") {{ ratios.ttmrevps }}
                                    span(class="values", v-else-if="!ratios.ttmrevps") -
                                li Price/Book
                                    span(class="values", v-if="ratios.pricebook") {{ ratios.pricebook }}
                                    span(class="values", v-else-if="!ratios.pricebook") -
                                li Price/Tangible Book
                                    span(class="values", v-if="ratios.pricetangiblebook") {{ ratios.pricetangiblebook }}
                                    span(class="values", v-else-if="!ratios.pricetangiblebook") -
                                li EPS Growth
                                    span(class="values", v-if="ratios.epsgrowth") {{ ratios.epsgrowth }}
                                    span(class="values", v-else-if="!ratios.epsgrowth") -
                                li Return on Equity
                                    span(class="values", v-if="ratios.returnonequity") {{ ratios.returnonequity }}
                                    span(class="values", v-else-if="!ratios.returnonequity") -
                                li Quick Ratio
                                    span(class="values", v-if="ratios.qquickrati") {{ ratios.qquickrati }}
                                    span(class="values", v-else-if="!ratios.qquickrati") -
                            div(class="fundamentals-details end-16")
                                li Consensus
                                    span(class="values", v-if="forecast.consrecom") {{ forecast.consrecom }}
                                    span(class="values", v-else-if="!forecast.consrecom") -
                                li Recommendation
                                    span(class="values", v-if="forecast.projltgrowthrate") {{ forecast.projltgrowthrate }}
                                    span(class="values", v-else-if="!forecast.projltgrowthrate") -
                                li Long Term Growth Rate
                                    span(class="values", v-if="forecast.projpe") {{ forecast.projpe }}
                                    span(class="values", v-else-if="!forecast.projpe") -
                                li Price to EPS
                                    span(class="values", v-if="forecast.projsalesq") {{ forecast.projsalesq }}
                                    span(class="values", v-else-if="!forecast.projsalesq") -
                                li Salary(Quarterly) 
                                    span(class="values", v-if="forecast.targetprice") {{ forecast.targetprice }}
                                    span(class="values", v-else-if="!forecast.targetprice") -
                            div(class="fund-detail end-16")
                                li Dividend
                                    span(class="values", v-if="marketData[7286]") {{ marketData[7286] }}
                                    span(class="values", v-else-if="!marketData[7286]") -
                                li Dividend Yield
                                    span(class="values", v-if="marketData[7287]") {{ marketData[7287] }}
                                    span(class="values", v-else-if="!marketData[7287]") -
                                li Ex-Date
                                    span(class="values", v-if="marketData[7288]") {{ marketData[7288] }}
                                    span(class="values", v-else-if="!marketData[7288]") -
</template>

<script>
import api from '../api';
import { mapState, mapActions, mapGetters } from 'vuex';
import tradingChart from '../js/TradingChart.js';

export default {
    name: 'SearchProducts',
    components: {
    },
    data() {
        return {
            show: false,
            iframeURL: '',
            exchange: '',
            quoteDetailsCookie: '',
            nightlyCookie: '',
            langCookie: '',
            results: '',
            summary: '',
            ratios: '',
            forecast: '',
            assetName: '',
            listingExchange: '',
            isSummary: true,
            quoteDetailsCookieValue: '',
            showQuoteDetails: '',
            reloadIframe: false,
            assetClass: '',
        }
    },
    mixins: [tradingChart],
    methods: {
        open(companyHeader, conid, underConid, type) {
            this.iframeURL = '';
            this.langCookie = document.cookie.split('IB_LANG=').pop().split(';').shift();
            
            // IB_NIGHTLY cookie is set manually. When the cookie value is 1, nightly iframe is loaded
            this.nightlyCookie = document.cookie.split('IB_NIGHTLY=').pop().split(';').shift();

            // Update language value for Chinese and Japanese
            switch(this.langCookie) {
                case 'cn':
                    this.langCookie = "zh_CN";
                    break;
                case 'jp':
                    this.langCookie = "ja";
                    break;
            }

            console.debug("IB_LANG:", this.langCookie);

            // If IB_NIGHTLY cookie value is 1 or the app is access through test.php page, nightly iframe URL is used.
            if (this.nightlyCookie === '1' || window.location.href.search(/test.php/) != -1){
                if(type === 'OPT') {
                    this.iframeURL = `https://www.interactivebrokers.com/free.to.air/nightly/web1/index.html#/optionChain?`;
                } else {
                    this.iframeURL = `https://www.interactivebrokers.com/free.to.air/nightly/web1/index.html#/?`;
                }
            } else {
                if(type === 'OPT') {
                    this.iframeURL = `https://www.interactivebrokers.com/free.to.air/web1/index.html#/optionChain?`;
                } else {
                    this.iframeURL = `https://www.interactivebrokers.com/free.to.air/web1/index.html#/?`;
                }
            }

            if (type === 'STK' || type === 'ETF' || type === 'FUND' || type === 'BOND' || type === 'CASH' || type === 'CMDTY' || type === 'CRYPTO' || type === 'all'){
                if (type === 'STK' || type === 'all') {
                    this.iframeURL += `conid=${conid}&sectype=STK&lang=${this.langCookie}&ib_entity=${this.selectedDomain}`;
                }
                if (type === 'ETF' || type === 'FUND' || type === 'BOND' || type === 'IND' || type === 'CASH' || type === 'CMDTY' || type === 'CRYPTO') {
                    this.iframeURL += `conid=${conid}&sectype=${type}&lang=${this.langCookie}&ib_entity=${this.selectedDomain}`;
                }
                console.debug(this.iframeURL);
            } else if(type === 'OPT'){
                api.getSecdefData(underConid)
                    .then(response => {
                        this.assetClass = response.secdef[0].assetClass;
                        this.iframeURL += `underlyingSectype=${this.assetClass}&underlyingConid=${underConid}&lang=${this.langCookie}&ib_entity=${this.selectedDomain}`;
                        console.debug(this.iframeURL);
                    })
            }

            this.showQuoteDetails = "new";

            // Adding iframe to DOM
            setTimeout(() => {
                this.reloadIframe = true;
                this.show = true;
            }, 50)
        },
        getSummary(conid) {
            api.getSummary(conid)
                .then(response => {
                    this.summary = response.summary.replace(/&amp;/g, "&");
                    this.ratios = response.ratios;
                    this.forecast = response.forecast;
                    console.log("Summary API call successfull..",);
                })
                .catch(error => {
                    if(error.response.status != 200){
                        this.isSummary = false;
                    }
                });
            api.getSecdefData(conid)
                .then(response => {
                    this.assetName = response.secdef[0].name;
                    this.listingExchange = response.secdef[0].listingExchange;
                })  
        },
        openDisclosure() {
            window.open("https://ibkr.info/article/2966","_blank", "width=800px, height=500px");
        },
        showContractDetails() {
            if(window.location.href.search(/test.php/) != -1){
                this.showQuoteDetails = "new";
            } else if((this.quoteDetailsCookieValue.length > 1 && this.quoteDetailsCookie === '1') || this.nightlyCookie === '1'){
                this.showQuoteDetails = "new";
            } else if(this.quoteDetailsCookieValue.length > 1 && this.quoteDetailsCookie === '0'){
                console.debug("Old contract details page");
                this.showQuoteDetails = "old";
            } else {
                console.debug("Old contract details page");
                this.showQuoteDetails = "old";
            }
        },
        close() {
            this.show = false;
            this.iframeURL = '';
            this.reloadIframe = false;
            this.summary = '';
            this.ratios = '';
            this.forecast = '';
            this.assetName = '';
            this.listingExchange = '';
            this.isSummary = true;
            this.resetValues();
        },
        ...mapActions(['setProductResults','setProducts', 'setTypesList'])
    },
    computed: {
        ...mapGetters(['selectedSubDomain', 'selectedDomain']),
        ...mapState(['listedResults', 'productResults', 'summaryy', 'forecst', 'marketdata', 'exchanges'])
    }
}
</script>

<style lang="less">
.comp-dialog {
    border-top: 5px solid #d91222;
}
.contract-details {
    width: 100%;
    margin-top: 10px;
}
.quote-details {
    color: black;
}
.quote-details-headers {
    border-bottom: 1px solid #d4d4d4;
    display: flex;
}
.quote-askbid {
    display: flex;
    padding-left: 28px;
    padding-top: 24px;
}
.symprice {
    padding-left: 16px;
}
.quote-details-data {
    //margin-left: 8px;
    font-size: 22px;
}
.summary {
    text-align: left;
    color: black;
    padding: 16px;
    border-bottom: 1px solid #d4d4d4;
}
.fundamentals-details {
    align-self: stretch;
}

.fundamentals-details li {
    list-style: none;
}
.fund-detail {
    align-self: stretch;
}
.fund-detail li {
    list-style: none;
}
.values {
    float: right;
    font-weight: bold;
}
.disclose-link {
    color: blue;
    cursor: pointer;
}
.alignment {
    position: relative;
    left: 50%;//
}
.warning {
    display: block;
    margin: auto;
    text-align: center;
    svg {
        width: 5%;
        height: 5%;
    }
}
.warn-message {
    padding-top: 16px;
    display: block;
    margin: auto;
    text-align: center;
}
.icon-close {
    position: absolute;
    right: 10px;
    top: 10px;
    svg {
        width: 2rem;
    }
}
.iframe-headers {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-top: 16px;
}
.iframe-header-info {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}

@media (max-width:768px) {
    .headers {
        display: flex;
        flex-direction: column;
    }
    .header-info {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #d4d4d4;
    }
    .product-name {
        width: 100%;
        padding-right: 20px;
    }
    .disclose {
        width: 100%;
        text-align: left;
    }
    .fundamentals {
        color:black;
        flex-direction: column;
        padding-top: 24px;
    }
    .fundamentals-details {
        padding-left: 16px;
    }
    .fund-detail {
        padding-left: 16px;
    }
}
@media (min-width:768px) {
    .headers {
        display: flex;
        flex-direction: column;
    }
    .header-info {
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid #d4d4d4;
    }
    .product-name {
        width: 40%;
        box-sizing: border-box;
        padding-right: 20px;
    }
    .disclose {
        width: 55%;
        height: 90%;
        text-align: left;
    }
    .fundamentals {
        color:black;
        flex-direction: row;
        padding-top: 24px;
    }
    .fundamentals-details {
        border-right: 1px solid #d4d4d4;
        margin-right: 20px;
    }
}
</style>

